<h1 mat-dialog-title>{{'Success' | translate}}</h1>
<div mat-dialog-content>
    <p>
       {{' User registered succesfully! You can Sign In.' | translate}}
    </p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">{{'Ok' | translate}}</button>    
</div>